module.exports = JSON.parse('{"Tracked series":"{{trackedSeries}} سلسلة متتبعة"}')